import { ref } from 'vue'
import { cookie } from '@/utils/cookie'

export function useProducts (brandId, eventId) {
  const products = ref([])
  const isLoading = ref(false)
  const error = ref(null)

  async function fetchProducts () {
    isLoading.value = true
    error.value = null

    try {
      const response = await fetch(
        `${window.vueAppConfig.endpoint}/api/v2/events/cart/list`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            brand_id: brandId,
            event_slug: eventId,
            session_id: cookie()
          })
        }
      )

      const data = await response.json()
      if (data.status) {
        products.value = data.products
      } else {
        error.value = 'Failed to load products'
      }
    } catch (err) {
      error.value = 'Error fetching products'
    } finally {
      isLoading.value = false
    }
  }

  return {
    products,
    isLoading,
    error,
    fetchProducts
  }
}
